import { HopperAssets } from "@hopper-assets";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { CloseIcon } from "../../assets";

export const OutageBanner = () => {
  const { t } = useI18nContext();
  const [closed, setClosed] = useState(false);
  const closeMe = useCallback(() => {
    setClosed(true);
  }, []);

  return closed ? null : (
    <Stack
      direction="row"
      spacing={200}
      sx={{
        backgroundColor: ({ tokens }) => tokens.colors.coral[60],
        padding: 100,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <Box>
        <Box
          component="img"
          src={HopperAssets.Ds.Thumb.Warning.IconRed_3x}
          alt="Warning"
          height="3em"
          sx={{
            verticalAlign: "center",
          }}
          textAlign="center"
        />
      </Box>
      <Stack direction="row" justifyContent="space-between" width="100%">
        <Stack direction="column" spacing={50} justifyContent="center">
          <Typography
            variant="titleMedium"
            color={({ tokens }) => tokens.colors.gray.white}
          >
            {t("outageBanner.title")}
          </Typography>
          <Typography
            variant="bodyMedium"
            color={({ tokens }) => tokens.colors.gray.white}
          >
            {t("outageBanner.text")}
          </Typography>
        </Stack>
        <Stack justifyContent="center" alignItems="center">
          <IconButton
            onClick={closeMe}
            sx={{
              color: ({ tokens }) => tokens.colors.gray[10],
              "&:hover": {
                backgroundColor: "#F36F6F",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Stack>
  );
};
